export const FETCH_CURRENT_USER_REQUEST = 'FETCH_CURRENT_USER_REQUEST';
export const FETCH_CURRENT_USER_SUCCESS = 'FETCH_CURRENT_USER_SUCCESS';
export const FETCH_CURRENT_USER_FAILED = 'FETCH_CURRENT_USER_FAILED';

export const FETCH_CONFERENCE_LIST_SUCCESS = 'FETCH_CONFERENCE_LIST_SUCCESS';

export const UPDATE_WINDOW_WIDTH = 'UPDATE_WINDOW_WIDTH';